import { InputLabel, makeStyles } from '@material-ui/core';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import InputLabelTooltip from '~components/input-label/input-label-tooltip';

const useStyles = makeStyles((theme) => ({
  root: {
    ...theme.flex.crossCenter,
    '& > * + *': { marginLeft: 4 },
  },

  label: {
    ...theme.typography.body1,
    color: theme.colors.grey66,
  },

  directionVertical: {
    ...theme.typography.h6,
    color: theme.colors.dark,
  },
}));

const Label = React.forwardRef((props, ref) => {
  const {
    direction = 'horizontal',
    tooltipTitle,
    children,
    className,
    InputLabelProps,
    TooltipProps,
    ...otherProps
  } = props;
  const classes = useStyles();

  return (
    <div {...otherProps} className={classNames(classes.root, className)} ref={ref}>
      {children && (
        <InputLabel
          {...InputLabelProps}
          className={classNames(
            classes.label,
            { [classes.directionVertical]: direction === 'vertical' },
            InputLabelProps?.className
          )}
        >
          {children}
        </InputLabel>
      )}

      {tooltipTitle && <InputLabelTooltip title={tooltipTitle} {...TooltipProps} />}
    </div>
  );
});

Label.propTypes = {
  direction: PropTypes.oneOf(['horizontal', 'vertical']),
  tooltipTitle: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string,
  InputLabelProps: PropTypes.object,
  TooltipProps: PropTypes.object,
};

Label.defaultProps = {
  direction: undefined,
  tooltipTitle: undefined,
  children: undefined,
  className: undefined,
  InputLabelProps: undefined,
  TooltipProps: undefined,
};

export default Label;
